export const NOT_STARTED = 'Not Started';
export const WORK_IN_PROGRESS = 'Work In Progress';
export const COMPLETE = 'Completed';
export const LOW_QUALITY = 'Low Quality';
export const GOOD_QUALITY = 'Good Quality';
export const HIGH_QUALITY = 'High Quality';
export const SOURCES = [
  'Transaction Monitoring',
  'Transaction Monitoring',
  'Name Screening',
  'Name Screening',
  'Transaction Screening',
  'Customer Risk Scoring',
  'Transaction Monitoring',
  'Name Screening',
  'Transaction Monitoring',
  'Transaction Screening'
];
